module.exports = __webpack_public_path__ + "media/images/top/qa/fv_left_img-61bd033a22c35c0eafd3f1d7c230fd9d.png";